import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";

export const moneyApi: any = createApi({
  reducerPath: "moneyApi",
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getMoneyPageData: builder.query<any, any>({
      query: (tab: string) => ({
        url: `/p/money/${tab}`,
        method: "GET",
      }),
    }),
    postLoanData: builder.mutation<any, any>({
      query: (data) => ({
        url: `/p/money/spend/order/loan`,
        method: "POST",
        data,
      }),
    }),
    getMoneyTaxHomeData: builder.query<any, any>({
      query: () => ({
        url: `/p/money/protect/tax`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetMoneyPageDataQuery,
  usePostLoanDataMutation,
  useGetMoneyTaxHomeDataQuery,
} = moneyApi;
